import { omitBy, isNil } from 'lodash';

export const deleteNilKeys = obj => omitBy(obj, isNil);
